/* global axios */
import ApiClient from '../ApiClient';

// Senha definida pelo administrador, com troca obrigatória no próximo acesso. A senha vai no
// corpo da requisição e não é guardada em lugar nenhum do lado do navegador.
class AgentSenhaAPI extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  definir(agentId, senha) {
    return axios.post(`${this.url}/${agentId}/definir_senha`, { senha });
  }
}

export default new AgentSenhaAPI();
